import { type SupportedLanguage } from '@centric-os/platform/i18n';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { PermissionScope } from '@centric-os/types';
import { defineStore, type StateTree } from 'pinia';
import { SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE } from '../../looker-locale';

export { LookerLocales, SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE } from '../../looker-locale';
export type { LookerLocale } from '../../looker-locale';

interface State extends StateTree {
  reportURL: string;
}

export function useReportStore(storeId = 'reports') {
  const store = defineStore(storeId, {
    state: (): State => ({
      reportURL: null,
    }),
    actions: {
      async postLookerEmbedUrl(url: string, locale: SupportedLanguage) {
        const { embed_url } = await this.serviceApi.post_user_embedurl({
          url,
          locale: SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE[locale],
        });

        this.reportURL = embed_url;
      },
    },
    getters: {
      canAccessReportsSection(): boolean {
        const authStore = useAuthStore();
        return authStore.hasPermissions([PermissionScope.reports]);
      },
    },
    pagination: false,
  });

  return store();
}
